<h1>Enjoy the latest issue</h1>
<span>While you wait for the next issue of JavaScript Weekly, check out the latest issue here.</span>
